import React from 'react';
import PropTypes from 'prop-types';
import { onRegexOnlyNumber } from 'common/stringUtils/toPositiveNumberString';

const propTypes = {
  delay: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onUpdate: PropTypes.func.isRequired,
};

const DelayInput = ({ delay, onUpdate }) => {
  return (
    <div className="input-group input-group-sm advanced-options-group">
      <div className="input-group-prepend">
        <span className="input-group-text">After</span>
      </div>
      <input
        type="text"
        className="form-control form-control-sm"
        value={delay}
        min="1"
        onChange={(event) => onUpdate(onRegexOnlyNumber(event.target.value))}
      />
      <div className="input-group-append">
        <span className="input-group-text">seconds</span>
      </div>
    </div>
  );
};

DelayInput.propTypes = propTypes;

export default DelayInput;
